module.exports = __webpack_public_path__ + "img/canbadge_animal_w60mm_line.806d06b3.png";